import { render, staticRenderFns } from "./FachkompetenzenUebernehmenModal.vue?vue&type=template&id=725f8b37&"
import script from "./FachkompetenzenUebernehmenModal.vue?vue&type=script&lang=js&"
export * from "./FachkompetenzenUebernehmenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports